module.exports = __webpack_public_path__ + "static/media/punjab.de8c4a3e.png";